'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pubsubDatastore = require('../../../ipns/routing/pubsub-datastore.js');
var errCode = require('err-code');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function getPubsubRouting(ipns, options) {
  if (!ipns || !(options && options.ipnsPubsub)) {
    throw errCode__default["default"](new Error('IPNS pubsub subsystem is not enabled'), 'ERR_IPNS_PUBSUB_NOT_ENABLED');
  }
  if (ipns.routing instanceof pubsubDatastore.IpnsPubsubDatastore) {
    return ipns.routing;
  }
  const pubsub = (ipns.routing.stores || []).find(s => s instanceof pubsubDatastore.IpnsPubsubDatastore);
  if (!pubsub) {
    throw errCode__default["default"](new Error('IPNS pubsub datastore not found'), 'ERR_PUBSUB_DATASTORE_NOT_FOUND');
  }
  return pubsub;
}

exports.getPubsubRouting = getPubsubRouting;
